"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildTimeAxis = buildTimeAxis;
exports.fillTimeAxisSeries = fillTimeAxisSeries;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/** 看板趋势图 X 轴：按时间 tab 生成完整刻度并补齐缺失点 */

function pad(n) {
  return String(n).padStart(2, '0');
}
function fmtDay(d) {
  return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()));
}
function buildMonthRangeKeys(startYm, endYm) {
  var keys = [];
  var _startYm$split$map = startYm.split('-').map(Number),
    _startYm$split$map2 = _slicedToArray(_startYm$split$map, 2),
    y = _startYm$split$map2[0],
    m = _startYm$split$map2[1];
  var _endYm$split$map = endYm.split('-').map(Number),
    _endYm$split$map2 = _slicedToArray(_endYm$split$map, 2),
    ey = _endYm$split$map2[0],
    em = _endYm$split$map2[1];
  while (y < ey || y === ey && m <= em) {
    keys.push("".concat(y, "-").concat(pad(m)));
    m += 1;
    if (m > 12) {
      m = 1;
      y += 1;
    }
  }
  return keys;
}

/**
 * @param {string} range today|recent7|recent30|week|month|quarter|year|all
 * @returns {{ keys: string[], labels: string[], mode: 'day'|'month', rotate: number }}
 */
function buildTimeAxis(range) {
  var now = new Date();
  var keys = [];
  var labels = [];
  var mode = 'day';
  var rotate = 0;
  if (range === 'all') {
    // 全部：默认近 12 个月占位；有数据时由 fillTimeAxisSeries 按实际跨度重建
    mode = 'month';
    var endYm = "".concat(now.getFullYear(), "-").concat(pad(now.getMonth() + 1));
    var start = new Date(now.getFullYear(), now.getMonth() - 11, 1);
    var startYm = "".concat(start.getFullYear(), "-").concat(pad(start.getMonth() + 1));
    var monthKeys = buildMonthRangeKeys(startYm, endYm);
    monthKeys.forEach(function (k) {
      keys.push(k);
      var _k$split = k.split('-'),
        _k$split2 = _slicedToArray(_k$split, 2),
        y = _k$split2[0],
        m = _k$split2[1];
      labels.push("".concat(y, "-").concat(Number(m), "\u6708"));
    });
    rotate = 40;
  } else if (range === 'year') {
    mode = 'month';
    var year = now.getFullYear();
    for (var m = 1; m <= 12; m++) {
      keys.push("".concat(year, "-").concat(pad(m)));
      labels.push("".concat(m, "\u6708"));
    }
  } else if (range === 'quarter') {
    mode = 'month';
    var _year = now.getFullYear();
    var startMonth = Math.floor(now.getMonth() / 3) * 3;
    for (var i = 0; i < 3; i++) {
      var _m = startMonth + i + 1;
      keys.push("".concat(_year, "-").concat(pad(_m)));
      labels.push("".concat(_m, "\u6708"));
    }
  } else if (range === 'month') {
    // 本月：1 号到月底每一天
    var _year2 = now.getFullYear();
    var month = now.getMonth();
    var lastDay = new Date(_year2, month + 1, 0).getDate();
    for (var day = 1; day <= lastDay; day++) {
      var d = new Date(_year2, month, day);
      keys.push(fmtDay(d));
      labels.push("".concat(pad(month + 1), "-").concat(pad(day)));
    }
    rotate = 40;
  } else if (range === 'week') {
    // 本周：周一到周日
    var _day = now.getDay();
    var mondayOffset = _day === 0 ? -6 : 1 - _day;
    var monday = new Date(now.getFullYear(), now.getMonth(), now.getDate() + mondayOffset);
    for (var _i = 0; _i < 7; _i++) {
      var _d = new Date(monday.getFullYear(), monday.getMonth(), monday.getDate() + _i);
      keys.push(fmtDay(_d));
      labels.push("".concat(pad(_d.getMonth() + 1), "-").concat(pad(_d.getDate())));
    }
  } else if (range === 'today') {
    keys.push(fmtDay(now));
    labels.push("".concat(pad(now.getMonth() + 1), "-").concat(pad(now.getDate())));
  } else if (range === 'recent7') {
    for (var _i2 = 6; _i2 >= 0; _i2--) {
      var _d2 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - _i2);
      keys.push(fmtDay(_d2));
      labels.push("".concat(pad(_d2.getMonth() + 1), "-").concat(pad(_d2.getDate())));
    }
  } else {
    // recent30 / 默认：近 30 天按日
    for (var _i3 = 29; _i3 >= 0; _i3--) {
      var _d3 = new Date(now.getFullYear(), now.getMonth(), now.getDate() - _i3);
      keys.push(fmtDay(_d3));
      labels.push("".concat(pad(_d3.getMonth() + 1), "-").concat(pad(_d3.getDate())));
    }
    rotate = 40;
  }
  return {
    keys: keys,
    labels: labels,
    mode: mode,
    rotate: rotate
  };
}

/**
 * 将原始按日数据填入完整 X 轴
 * @param {Array<{date?: string, registerDate?: string, value?: number, count?: number}>} rows
 * @param {string} range
 * @param {(row: object) => { keySource: string, values: Record<string, number> }} mapRow
 */
function fillTimeAxisSeries(rows, range, mapRow) {
  // 全部：按数据最早月份补齐到当前月，避免只显示本年
  if (range === 'all') {
    var now = new Date();
    var endYm = "".concat(now.getFullYear(), "-").concat(pad(now.getMonth() + 1));
    var temp = {};
    (rows || []).forEach(function (row) {
      var _mapRow = mapRow(row),
        keySource = _mapRow.keySource,
        values = _mapRow.values;
      if (!keySource) return;
      var key = String(keySource).substring(0, 7);
      if (!/^\d{4}-\d{2}$/.test(key)) return;
      if (!temp[key]) temp[key] = {};
      Object.keys(values).forEach(function (field) {
        temp[key][field] = (temp[key][field] || 0) + Number(values[field] || 0);
      });
    });
    var dataKeys = Object.keys(temp).sort();
    var startYm = dataKeys.length ? dataKeys[0] : function () {
      var start = new Date(now.getFullYear(), now.getMonth() - 11, 1);
      return "".concat(start.getFullYear(), "-").concat(pad(start.getMonth() + 1));
    }();
    var keys = buildMonthRangeKeys(startYm, endYm);
    var labels = keys.map(function (k) {
      var _k$split3 = k.split('-'),
        _k$split4 = _slicedToArray(_k$split3, 2),
        y = _k$split4[0],
        m = _k$split4[1];
      return "".concat(y, "-").concat(Number(m), "\u6708");
    });
    var _buckets = {};
    keys.forEach(function (k) {
      _buckets[k] = temp[k] || {};
    });
    return {
      axis: {
        keys: keys,
        labels: labels,
        mode: 'month',
        rotate: keys.length > 8 ? 40 : 0
      },
      buckets: _buckets
    };
  }
  var axis = buildTimeAxis(range);
  var buckets = {};
  axis.keys.forEach(function (k) {
    buckets[k] = {};
  });
  (rows || []).forEach(function (row) {
    var _mapRow2 = mapRow(row),
      keySource = _mapRow2.keySource,
      values = _mapRow2.values;
    if (!keySource) return;
    var key = axis.mode === 'month' ? String(keySource).substring(0, 7) : String(keySource).substring(0, 10);
    if (!buckets[key]) return;
    Object.keys(values).forEach(function (field) {
      buckets[key][field] = (buckets[key][field] || 0) + Number(values[field] || 0);
    });
  });
  return {
    axis: axis,
    buckets: buckets
  };
}